import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('driver-list/index', {params});
    },
    show(id) {
        return Service().get('driver-list/show/'+id);
    },
    create(params) {
        return Service().post('driver-list/create', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    update(id, params) {
        return Service().post('driver-list/update/'+id, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    delete(id) {
        return Service().post('driver-list/delete/'+id);
    },
    getDriver(params) {
        return Service().get('driver-list/get-driver', {params});
    },
}